<div class="pb-2 text-3xl font-extrabold">Compte</div>

<div class="flex justify-between">
  <div class="flex max-w-80 flex-col gap-1 py-2">
    <div class="text-xl leading-none font-semibold tracking-tight">Désactivation de votre compte</div>
    <div class="text-gray-11">Vous pourrez réactiver votre compte à tout moment en contactant le support</div>
  </div>
  <button class="link destructive" (click)="deactivateAccount.emit()" mat-button>
    <span> Désactiver </span>
  </button>
</div>
<mat-divider class="my-4"></mat-divider>
